const Onboard = () => (
  <svg
    width="55px"
    height="46px"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.454 5.965a6.723 6.723 0 1 0 0 13.446 6.723 6.723 0 0 0 0-13.446ZM9.268 12.688c0-6.73 5.456-12.186 12.186-12.186 6.73 0 12.186 5.456 12.186 12.186 0 6.73-5.456 12.186-12.186 12.186-6.73 0-12.186-5.456-12.186-12.186Zm25.454-9.586a2.731 2.731 0 0 1 3.433-1.77l.599.191a12.153 12.153 0 0 1-.497 23.3l-.214.058a2.731 2.731 0 1 1-1.44-5.27l.215-.058a6.69 6.69 0 0 0 .273-12.827l-.599-.191a2.731 2.731 0 0 1-1.77-3.433Zm8.916 28.005a2.731 2.731 0 0 1 3.255-2.08l1.29.284c4.517.996 7.735 5 7.735 9.626v5.821a2.731 2.731 0 0 1-5.462 0v-5.821a4.394 4.394 0 0 0-3.449-4.291l-1.29-.285a2.731 2.731 0 0 1-2.08-3.254Zm-30.99 3.319a6.769 6.769 0 0 0-6.77 6.768v3.564a2.731 2.731 0 0 1-5.462 0v-3.564c0-6.755 5.476-12.231 12.231-12.231h17.51c6.754 0 12.23 5.476 12.23 12.231v3.564a2.731 2.731 0 0 1-5.462 0v-3.564a6.769 6.769 0 0 0-6.769-6.769H12.647Z"
      fill="#5FA3A9"
    />
  </svg>
);

export default Onboard;
